export default "__VITE_ASSET__lbnmx02l__"